import { useEffect } from "react";
import { useAnalytics } from "../../contexts/analytics/hooks";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import type { CompositionMismatch } from "./wageComposition";

/**
 * Reports each gap too big to be rounding — a missing or wrong contribution line, or segment wages that do
 * not reach the total. The panel shows those figures un-itemized rather than labelling the gap "Rounding",
 * so without this the defect would be silent.
 */
export const useMismatchReport = (mismatches: CompositionMismatch[] | undefined) => {
	const { trackError } = useAnalytics();
	const { chosenDepartment } = useHospitalData();
	const departmentId = chosenDepartment.department_id;
	useEffect(() => {
		for (const mismatch of mismatches ?? []) {
			trackError("wage_breakdown_composition_mismatch", {
				department_id: departmentId,
				error_message: `Wage breakdown ${mismatch.kind} gap of ${mismatch.gapCents} cents exceeds rounding`,
				...(mismatch.kind === "rate"
					? { mismatch_kind: mismatch.kind, row_id: mismatch.rowId, gap_cents: mismatch.gapCents, line_count: mismatch.lineCount }
					: { mismatch_kind: mismatch.kind, gap_cents: mismatch.gapCents, segment_count: mismatch.segmentCount }),
			});
		}
	}, [mismatches, trackError, departmentId]);
};
